(() => {
  if (!document.body.classList.contains('joa-product-design')) return;
  const copyNode = document.querySelector('[data-joa-design-copy]');
  let copy = {};
  try { copy = { ...JSON.parse(document.querySelector('[data-joa-global-option-copy]')?.textContent || '{}'), ...JSON.parse(copyNode?.textContent || '{}') }; } catch (_) {}
  const text = (key) => copy[key] || key.replaceAll('_', ' ');
  const setText = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
  function enhance() {
    const container = document.querySelector('.joa-product-form .mw-apo-container:not(.joa-express-form .mw-apo-container)');
    window.JoaOptionDesign?.enhance(container, copyNode);
    const fieldset = document.querySelector('#hypehound-pre-orders');
    if (fieldset) {
      const approved = Boolean(container?.classList.contains('joa-approved-configurator') || document.querySelector('#MainContent .product-details[data-joa-config-details] .joa-native-options'));
      setText(fieldset.querySelector('legend'), text(approved ? 'payment' : 'how_to_begin'));
      const deposit = fieldset.querySelector('#purchase-option-deposit-wrapper');
      const full = fieldset.querySelector('#purchase-option-full-wrapper');
      if (deposit && full) {
        if (approved && deposit.nextElementSibling === full) fieldset.insertBefore(full, deposit);
        else if (!approved && full.nextElementSibling === deposit) fieldset.insertBefore(deposit, full);
      }
    }
  }

  document.addEventListener('joa:product-enhanced', enhance);
  document.addEventListener('change', enhance);
  document.addEventListener('joa:engraving-change', enhance);
  enhance();

})();
